module.exports = __webpack_public_path__ + "static/media/Booksy.512a7fac.png";